import Swiper from 'swiper'

// ALU
const alu = document.querySelector('.slideshow .swiper-container') !== null;

if (alu) {
    let nbSlides = document.querySelectorAll('.slideshow .swiper-container .swiper-slide').length;
    let dataSlideAuto = document.querySelector('.slideshow .swiper-container').getAttribute('data-slide_auto');
    let dataSlideSpeed = document.querySelector('.slideshow .swiper-container').getAttribute('data-slide_speed');
    dataSlideSpeed = dataSlideSpeed + '000';

    let config = {
        slidesPerView: 1,
        effect : 'fade',
        grabCursor : 'true',
        speed: 700,
        loop : true,

        keyboard: {
            enabled: true,
        },

        mousewheel: {
            forceToAxis: true,
            releaseOnEdges : true,
        },

        pagination: {
            el: '.slideshow__pagination',
            type: 'bullets',
            clickable: true
        }
    }

    if (dataSlideAuto === '1'){
        config.autoplay = {
            delay: dataSlideSpeed,
            disableOnInteraction: false,
        }
    }

    if (nbSlides > 1) {
        let swiperHome = new Swiper('.slideshow .swiper-container', config);
    }
}


